var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('button',{staticClass:"floating-customer-service",style:(_vm.positionStyle),attrs:{"type":"button","aria-label":_vm.$t('webindex.custserver')},on:{"click":function($event){$event.stopPropagation();return _vm.openService.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.avatar,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }